<template>
    <div>
        <div style="height: 600px;">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
            
        },
    }
</script>

<style lang="scss" scoped>
</style>